export const parseFormErrors = (json: any, keys: string[]) => {
  if (!Array.isArray(json.errors)) {
    return {};
  }

  return (json.errors as Array<{ attribute: string; message: string }>).reduce<
    Record<string, string[]>
  >((errors, { attribute, message }) => {
    const errorKey = keys.includes(attribute) ? attribute : "general";
    errors[errorKey] = [...(errors[attribute] ?? []), message];

    return errors;
  }, {});
};
